export const styles = {
    /* ── Page ── */
    pageWrapper: {
        padding: '24px 28px',
        minHeight: '100vh',
        background: '#f8fafb',
    },

    /* ── Top bar ── */
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '18px',
        flexWrap: 'wrap',
        gap: '12px',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
    },
    btnBack: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '7px 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
    },
    pageTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    pageTitleIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '9px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    pageTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    countBadge: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '2px 10px',
    },
    headerRight: {
        width: '80px',
    },

    /* ── Table card ── */
    tableCard: {
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    tableScroll: {
        overflowX: 'auto',
        maxHeight: '72vh',
        overflowY: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13.5px',
    },
    theadRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
        position: 'sticky',
        top: 0,
        zIndex: 10,
    },
    th: {
        padding: '11px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        userSelect: 'none',
    },
    thNoSort: {
        padding: '11px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
    },
    row: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
    },
    td: {
        padding: '11px 16px',
        color: '#374151',
        fontSize: '13.5px',
        verticalAlign: 'middle',
    },
    indexCell: {
        padding: '11px 16px',
        color: '#9ca3af',
        fontWeight: '600',
        fontSize: '13px',
        verticalAlign: 'middle',
        width: '52px',
    },
    boardNameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    boardIcon: {
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
    },
    boardNameText: {
        fontWeight: '600',
        color: '#111827',
    },
    dateBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f3f4f6',
        borderRadius: '20px',
        fontSize: '12px',
        color: '#6b7280',
        fontWeight: '500',
        whiteSpace: 'nowrap',
    },
    statusCell: {
        verticalAlign: 'middle',
        padding: '11px 16px',
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        padding: '11px 16px',
        verticalAlign: 'middle',
    },
    btnAdd: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #d1fae5',
        background: '#f0fdf4',
        color: '#1a7d3e',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '16px',
    },
    btnDelete: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #fecaca',
        background: '#fee2e2',
        color: '#dc2626',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '16px',
    },

    /* ── Pagination ── */
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        marginTop: '18px',
        marginBottom: '8px',
    },
    paginationBtn: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '1.5px solid #bbf7d0',
        background: '#fff',
        color: '#1a7d3e',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    },
    paginationBtnDisabled: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '1.5px solid #e5e7eb',
        background: '#f9fafb',
        color: '#d1d5db',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'not-allowed',
        boxShadow: 'none',
    },
    paginationText: {
        fontSize: '13.5px',
        fontWeight: '600',
        color: '#374151',
    },
    paginationHighlight: {
        color: '#1a7d3e',
    },

    /* ── Empty state ── */
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '56px 0',
    },
    emptyText: {
        marginTop: '14px',
        fontSize: '14px',
        color: '#9ca3af',
        fontWeight: '500',
    },
};
